import { render, staticRenderFns } from "./CampaignListTrophies.vue?vue&type=template&id=8d7d3b82&scoped=true"
import script from "./CampaignListTrophies.vue?vue&type=script&lang=js"
export * from "./CampaignListTrophies.vue?vue&type=script&lang=js"
import style0 from "./CampaignListTrophies.vue?vue&type=style&index=0&id=8d7d3b82&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d7d3b82",
  null
  
)

export default component.exports